<!--
 * @Description: 
 * @Autor: kangpeng
 * @Date: 2020-04-17 10:17:41
 * @LastEditors: kangpeng
 * @LastEditTime: 2020-06-08 11:38:06
 -->
<template>
    <div id="app" ref="appWrap">
        <el-backtop target="#app" :bottom="100">
            <div class="back_top">
                <i class="el-icon-top"></i>
            </div>
        </el-backtop>
        <div @click.stop="handleToOpenQQ" v-show="isShow" class="kf_wrap">
            <img src="./assets/img/home_img/kf.png" alt />
            <i @click.stop="handleToClose" class="el-icon-close icon"></i>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import BScroll from "better-scroll";
export default {
    name: "App",
    data() {
        return {
            isShow: true
        };
    },
    mounted() {
        
    },
    watch:{
       '$route.fullPath'() {
            this.$refs.appWrap.scrollTop = 0
        }
    },
    methods: {
        /**
         * @description: 关闭客服弹窗
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleToClose() {
            this.isShow = false;
        },
        /**
         * @description: 唤起qq
         * @param {type}
         * @return:
         * @author: kangpeng
         */
        handleToOpenQQ() {
            window.location.href =
                "http://wpa.qq.com/msgrd?v=3&uin=3163474521&site=qq&menu=yes";
        }
    }
};
</script>

<style>
ul,
li {
    padding: 0;
    margin: 0;
    list-style: none;
}
a,
a:link,
a:visited,
a:hover,
a:active {
    text-decoration: none;
    color: inherit;
}
i {
    font-style: normal;
}
#app {
    width: 100%;
    height: 100vh;
    overflow-x: hidden;
    background: #fff;
}
#app .kf_wrap {
    cursor: pointer;
    width: 120px;
    position: fixed;
    z-index: 999;
    top: 50%;
    right: 40px;
}
#app .kf_wrap img {
    width: 120px;
}
#app .kf_wrap .icon {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
}
.back_top {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #00988a;
    color: #fff;
}
.back_top:hover {
    transition: all 0.28s ease-out;
    background-color: #10baaa;
}
</style>
